import appendNestedParams from "@utils/helpers/window/appendNestedParams";

export default function buildUrl(url, params = {}) {
  const targetLocation = new URL(url);
  const urlSegments = [targetLocation.origin];

  if (targetLocation.pathname && targetLocation.pathname !== "/") {
    urlSegments.push(targetLocation.pathname);
  }

  const urlSearchParams = new URLSearchParams();
  appendNestedParams(urlSearchParams, params);
  const paramsString = urlSearchParams.toString();

  if (paramsString) {
    urlSegments.push("?", paramsString);
  }

  const outputUrl = urlSegments.join("");
  return outputUrl;
}
